import { Typography, Card, Box, Divider, useMediaQuery, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import { StatusLabel } from "../../../components/Label/status";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { formatCrypto, formatDateTime, formatEuro, networkLabel } from "../../../utils/paymentFormat";

function InfoOrderTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));
  const record = useRecordContext();
  const currency = String(record.currency || "").toUpperCase();

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("Summary")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Amounts, payment address and status of this transaction.")}
          </Typography>
        </Box>
      )}

      <AnimatedBlock>
        <Card>
          <Box px={2} pt={2.5} pb={1.5}>
            <Typography variant="h5" fontWeight="bold">
              {t("Transaction")}
            </Typography>
          </Box>
          <Divider />
          <Box px={2} py={1}>
            <InfoRow label={t("Reference")}>{record.internalRef}</InfoRow>
            <InfoRow label={t("Status")}>
              <StatusLabel />
            </InfoRow>
            {record.euroAmount !== undefined && <InfoRow label={t("Euro amount")}>{formatEuro(record.euroAmount)}</InfoRow>}
            <InfoRow label={t("Payout amount")}>{record.quoteAmount !== undefined ? formatEuro(record.quoteAmount) : "—"}</InfoRow>
            <InfoRow label={t("Crypto amount")}>
              {formatCrypto(record.amount)} {currency}
            </InfoRow>
            {record.network && <InfoRow label={t("Network")}>{networkLabel(record.network)}</InfoRow>}
            {record.publicAddressDest && (
              <InfoRow label={t("Payment address")}>
                <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 13 }}>
                  {record.publicAddressDest}
                </Typography>
              </InfoRow>
            )}
            <InfoRow label={t("Created date")}>{formatDateTime(record.dateCreated)}</InfoRow>
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoOrderTab;
